import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useCanCreateUser = (): boolean => {
  const [canCreateUser, setCanCreateUser] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const createAllPermission: Permission = {
    resource: 'users',
    action: 'createbasic',
    scope: 'all',
  };

  const canCreateAll = useHasPermission(user, createAllPermission);

  React.useEffect(() => {
    setCanCreateUser(canCreateAll);
  }, [canCreateAll]);

  return canCreateUser;
};
